export class LocationError extends Error {

}